import React from 'react';
import { RequisitionStatus } from '../../../../entities/v1/applicant_tracking/Requisition';
import { ChipColor, Chip } from '../../../Chip';

export function StatusChip(props: { status: RequisitionStatus }) {
  let statusChipColor: ChipColor;
  let statusText: string;

  switch (props.status.toString()) {
    case RequisitionStatus.Approved.toString():
      statusChipColor = ChipColor.Success;
      statusText = 'Approved';
      break;
    case RequisitionStatus.Completed.toString():
      statusChipColor = ChipColor.Blue;
      statusText = 'Completed';
      break;
    case RequisitionStatus.Declined.toString():
      statusChipColor = ChipColor.Danger;
      statusText = 'Declined';
      break;
    case RequisitionStatus.Pending.toString():
      statusChipColor = ChipColor.Blue500;
      statusText = 'Awaiting for approval';
      break;
  }

  if (statusText == null) return;

  return (
    <Chip className={'fw-semibold mx-3'} color={statusChipColor}>
      {statusText}
    </Chip>
  );
}
